/** Tier keys alineados con `mejores_amigos_price_config` (admin 💰/💎). */
export type MejoresAmigosTierKind =
  | "medium"
  | "high"
  | "custom"
  | "fallback"
  | "internal";

/** URLs globales por defecto (seed SQL 053 / api/admin/mejores-amigos-config). */
export const MEJORES_AMIGOS_DEFAULT_MP_URLS = {
  medium:
    "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=b5eea4dde1184b8f84ec2a0db1be75e1",
  high: "https://www.mercadopago.com.ar/subscriptions/checkout?preapproval_plan_id=9a7bd6e8e678479991bfb847ed192653",
} as const;

export type MejoresAmigosTierUrls = {
  medium?: { url: string; label?: string };
  high?: { url: string; label?: string };
};

export function extractMpPlanId(url: string | undefined): string | undefined {
  const u = (url ?? "").trim();
  if (!u) return undefined;
  try {
    const parsed = new URL(u, "https://www.mercadopago.com.ar");
    const id = parsed.searchParams.get("preapproval_plan_id");
    return id?.trim() || undefined;
  } catch {
    const match = u.match(/preapproval_plan_id=([a-f0-9-]+)/i);
    return match?.[1];
  }
}

export function isMercadoPagoCheckoutUrl(url: string | undefined): boolean {
  const u = (url ?? "").trim();
  if (!u) return false;
  return (
    /mercadopago\.com/i.test(u) ||
    /preapproval_plan_id=/i.test(u)
  );
}

/**
 * Infiere tier activo comparando `ctaUrl` con tiers globales (Worker/DB)
 * y los defaults hardcodeados.
 */
export function inferMejoresAmigosTier(
  ctaUrl: string | undefined,
  tiers?: MejoresAmigosTierUrls,
): MejoresAmigosTierKind {
  const u = (ctaUrl ?? "").trim();
  if (!u) return "fallback";
  if (!/^https?:\/\//i.test(u)) return "internal";

  const mediumUrl =
    tiers?.medium?.url?.trim() || MEJORES_AMIGOS_DEFAULT_MP_URLS.medium;
  const highUrl =
    tiers?.high?.url?.trim() || MEJORES_AMIGOS_DEFAULT_MP_URLS.high;

  if (u === mediumUrl) return "medium";
  if (u === highUrl) return "high";

  const planId = extractMpPlanId(u);
  if (planId) {
    if (planId === extractMpPlanId(mediumUrl)) return "medium";
    if (planId === extractMpPlanId(highUrl)) return "high";
  }

  return "custom";
}